export default __webpack_public_path__ + "static/media/10n.586fce3b.svg";